import { gql } from '@apollo/client/core'
import { useMutation } from '@vue/apollo-composable'
import { ILoginResponse } from '@types'

const LOGIN_MUTATION = gql`
  mutation Login($loginInput: LoginInput!) {
    login(loginInput: $loginInput) {
      payload {
        ... on LoginResponse {
          accessToken
          email
          name
          refreshToken
          id
          favorites
        }
      }
      type
    }
  }
`

/**
 * Hook para a mutação de login.
 * @returns A mutação de login.
 */
export const useLoginMutation = () => {
  const mutation = useMutation<ILoginResponse>(LOGIN_MUTATION)
  return mutation
}
